export default __webpack_public_path__ + "static/media/actions.9f0201bb.svg";